export function setContacts(state, contacts) {
  state.contacts = contacts;
}
export function setParamsContacts(state, filter) {
  state.params_contacts.filter = filter;
}
export function setLines(state, lines) {
  state.lines = lines;
}
export function setBrands(state, brands) {
  state.brands = brands;
}
export function setSellingPricesAboveCost(state, sellingPricesAboveCost) {
  state.sellingPricesAboveCost = sellingPricesAboveCost;
}
export function setSellingPricesAboveCosts(state, sellingPricesAboveCosts) {
  state.sellingPricesAboveCosts = sellingPricesAboveCosts;
}



// WEBPACK FOOTER //
// ./src/modules/selling-prices-above-cost/mutations.js